import type { Ref } from 'react';
import { Button } from '@ksyos/design-system';
import { translateKey } from '../../../translate';

export function SaveButton(props: {
    buttonDisabled?: boolean;
    save: () => Promise<void>;
    saveButtonRef?: Ref<HTMLButtonElement>;
    tabIndex?: number;
}) {
    return (
        <Button
            buttonRef={props.saveButtonRef}
            className="automation-save"
            data-automation-test="save"
            isDisabled={props.buttonDisabled}
            onClick={props.save}
            tabIndex={props.tabIndex}
            type="button"
            variant="outline"
        >
            {translateKey('common.saveDraft')}
        </Button>
    );
}
